
module.exports = [
  {
    name: "Summary Template",
    description: `
      A responsive template that lists review stats, link, and reviews. 
    `,
    template: require('./samples/responsiveSummary.hbs'),
    previewImg:  "/images/reviewBuilder/ResponsiveSummary.png",
    placeholderLogo: "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
    widgetType: 'review',
    templateParams: {},
    maxReviews: 5,
    minRating: 4,
    featureTags: ['Summary']
  },
  {
    name: "Basic List View",
    description: `
      A clean template that lists reviews with author. 
    `,
    template: require('./samples/basicList.hbs'),
    previewImg:  "/images/reviewBuilder/BasicList.png",
    widgetType: 'review',
    templateParams: {},
    maxReviews: 5,
    minRating: 4
  },
  {
    name: "Carousel",
    description: `
    A rotating carousel that displays reviews in a flash-card style format.
    `,
    template: require('./samples/carousel.hbs'),
    previewImg: "/images/reviewBuilder/Carousel.png",
    placeholderLogo: "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
    widgetType: 'review',
    templateParams: {},
    maxReviews: 5,
    minRating: 4
  }
];
